import { CategoryInterface, OnlineBookingMeth } from 'types';

export const moveConsultationToFirst = (
  categories: CategoryInterface[]
): CategoryInterface[] => {
  const isCategoryExist = categories.length > 0;

  if (isCategoryExist) {
    const consultationIndex = categories.findIndex(
      (category) => category.name.toLowerCase() === 'consultation'
    );
    if (consultationIndex !== -1) {
      const updatedCategories = [...categories];
      const consultationCategory = updatedCategories.splice(
        consultationIndex,
        1
      )[0];
      updatedCategories.unshift(consultationCategory);
      return updatedCategories;
    }
  }
  return categories;
};

export const getTooltipLabelServcie = (
  isAuth: boolean,
  method: OnlineBookingMeth
) => {
  if (isAuth) {
    return 'This service is reserved for existing clients.';
  }
  if (method !== OnlineBookingMeth.Everyone) {
    return 'This service is reserved for existing clients. Please sign in to see if you qualify.';
  }

  return '';
};

export const getAllowServiceToCheck = (
  isAuth: boolean,
  method: OnlineBookingMeth
) => {
  if (isAuth) {
    return (
      method === OnlineBookingMeth.Everyone ||
      method === OnlineBookingMeth.ExistingClientsOnly
    );
  }
  return method === OnlineBookingMeth.Everyone;
};
